import { Box, Divider, Skeleton } from "@chakra-ui/react";
import { useQueryParams } from "@madkom/query-params";
import { useHistory } from "react-router-dom";

import { useGetFriendlyUrl } from "utils/hooks/useGetFriendlyUrl";

import { useGetPaginatedUserAppointments } from "../../../../infrastructure/useGetPaginatedUserAppointments";
import { AppointmentMobileRow } from "../../components/AppointmentMobileRow";
import {AppointmentActionButtons} from "../ActualAppointmentsTable/AppointmentActionButtons";

interface IProps {
  limit: number;
}

const ActualAppointmentsMobileRows = ({ limit }: IProps) => {
  const { push } = useHistory();
  const { friendlyUrl } = useGetFriendlyUrl();
  const { params } = useQueryParams<{ offset: number }>();
  const { data: appointments, isFetched } = useGetPaginatedUserAppointments(
    {
      limit: limit,
      offset: params.offset,
    },
    {
      suspense: false,
    }
  );

  if (!appointments || !isFetched) {
    return (
      <>
        {Array.from(Array(limit).keys()).map((key) => {
          return (
            <Box my={2} key={key}>
              <Skeleton h="80px" isLoaded={false} />
              <Divider mt={2} />
            </Box>
          );
        })}
      </>
    );
  }

  return (
    <>
      {appointments.userAppointments.map((appointment) => {
        return (
          <AppointmentMobileRow
            my={2}
            onClick={() =>
              push(
                `/e-rezerwacja/${friendlyUrl}/uzytkownik/aktualne-wizyty/${appointment.appointmentId}`
              )
            }
            appointment={appointment}
            actionButtons={
              <AppointmentActionButtons appointment={appointment} />
            }
          />
        );
      })}
    </>
  );
};

export { ActualAppointmentsMobileRows };
